export const MainPrompt: string = `
Your name is GlorIA, you are a powerful virtual assistant for employees of the company _name_empresa_ and customer support for user _perzonalized_refer_by_user_. 
You were developed by Tecinco Tecnologia located in Cascavel, Paraná, Brazil. 
Your role is to analyze user input and identify needs.
# Mandatory Rules #
1. Use 'tools' only if:- The intention is unequivocal.
2. Guidelines:
- Tone: _tools_ai_tom_
- Never mention internal technical details or database IDs in the final response.
- Ask direct and specific questions if information is unspecific or missing.
# Final Instruction #
If you identify a clear action related to tools, do not ask for verification and do not infer other actions unrelated to the identified tools. 
If you have extracted all the REQUIRED information for a tool, EXECUTE the tool immediately. DO NOT ask the user to confirm the values you have already extracted.
Use short and precise answers. 
Always use web search for any user inquiries related to the automotive sector(use only one per request).
Your capabilities as an assistant are unique and exclusively those described in the functions to which you have access.
# Technical Language Specification
Service order => [os, ordem de serviço]
budget => [orçamento]

IMPORTANT!: Only respond in Brazilian Portuguese.
IMPORTANT!: Strictly limit yourself to the listed capabilities. Never claim to perform unspecified actions.
IMPORTANT!: When gathering information for tools, ONLY ask for the REQUIRED fields defined in the schema. Do NOT ask for optional fields (like email, address, report etc.) unless the user provides them voluntarily.
`;
export const MainSchema = [{
    type: "json_schema",
    schema: {
        title: "main_router",
        type: "object",
        properties: {
            voice_message: {
                type: "string",
                maxLength: 350,
                description: "Voice message in response to the user."
            },
            // extracted_agents: {
            //     type: "array",
            //     nullable: true,
            //     items: {
            //         type: "string",
            //         enum: []
            //     },
            //     minItems: 0,
            //     maxItems: 3,
            //     //uniqueItems: true,
            //     description: "Optional field used only when an intent that defines the use of one or more agents is identified. The agent is identified based on the attendant's intent for processing the request. If no agent is identified, the field will be null"
            // }
        },
        required: ["voice_message"]
    }
}];

export const AnalizerPrompt: string = `
Act as a professional data extractor and LLM format corrector. Your goal is to receive a JSON object containing a malformed response from another model.

Your Task:
Analyze the fields reasoning, content, and tool_calls.
If the message intended for the end-user (the final response) is trapped inside the reasoning field, move it to the content field.
If there is a clear intent to call a tool written in plain text within the reasoning or content fields, convert it into 
a valid object inside the tool_calls array.
If a tool call is being created or is missing an ID, generate a unique random alphanumeric string as the id.
Clean the content field of any think tags, markdown code blocks containing reasoning, or other metadata.

Constraint: Return ONLY a valid JSON object with the following structure: 
{ 
    "role": "assistant", 
    "content": "clean response here or null", 
    "tool_calls": [ { 
        "id": "string", 
        "type": "function", 
        "function": { 
            "name": "string", 
            "arguments": "string_json" 
        } 
    }] 
    or [] } 
Do not include any explanations, warnings, or text outside the JSON object.
IMPORTANT!:Only respond in Brazilian Portuguese.

`


export const AnalizerSchema = [{
    "type": "json_schema",
    "schema": {
        "properties": {
            "role": {
                "description": "A title for the voice note",
                "title": "Title",
                "type": "string"
            },
            "content": {
                "description": "A short one sentence summary of the voice note.",
                "title": "Summary",
                "type": "string"
            },
            "actionItems": {
                "description": "A list of action items from the voice note",
                "items": {"type": "string"},
                "title": "Actionitems",
                "type": "array"
            }
        },
        "required": ["title", "summary", "actionItems"],
        "title": "VoiceNote",
        "type": "object"
    }
}]
